<template>
  <button
    class="link text-xs font-semibold underline"
    type="button"
    @click="handleClick"
  >
    Order Swatch Book
  </button>
</template>

<script>
import { mapActions, mapMutations } from "vuex";

export default {
  name: "ProductSwatchBook",
  props: {
    title: {
      type: String,
      required: true,
    },
    product: {
      type: [Object, Boolean],
      required: true,
    },
  },

  methods: {
    ...mapMutations(["openSiteCart"]),
    ...mapActions("cart", ["addItem"]),

    handleClick() {
      this.addItem({
        purchasable: this.product,
        options: { swatchBook: this.title },
      });
      this.openSiteCart();
    },
  },
};
</script>
